import { Injectable } from "@angular/core";
import { AppFilter } from "src/app/application/applications.component";

@Injectable({
  providedIn: 'root'
})
export class ApplicationFilterService {
  buildFilterString(filter: AppFilter): string {
    const filterStringBuilder = getFilterStringBuilder(filter);

    if (!filterStringBuilder) {
      return '';
    }

    return filterStringBuilder.buildString();
  }
}

abstract class FilterStringBuilder {
  protected filter: AppFilter;
  constructor(filter: AppFilter) {
    this.filter = filter;
  }

  abstract buildString(): string;
}


class RCCodeFilterStringBuilder extends FilterStringBuilder {
  constructor(filter: AppFilter) {
    super(filter);
  }

  buildString(): string {
    const operator = this.filter.operator === '!'
      ? Operator.NOT_IN : Operator.IN;

    const { criteria, field } = this.filter;
    const stringifiedCriteria = criteria.map(value => `'${value}'`);

    return `${field} ${operator} (${stringifiedCriteria.join(',')})`;
  }
}

function getFilterStringBuilder(filter: AppFilter): FilterStringBuilder | null {
  if (filter.field === Filters.RC_CODE) {
    return new RCCodeFilterStringBuilder(filter);
  }

  return null;
}


enum Operator {
  IN = 'IN',
  NOT_IN = 'NOT IN'
}

enum Filters {
  RC_CODE = 'rcCode'
}
